import React from 'react';
import $ from "jquery";

const Marker = ({ text }) => {
  const handleClick = (e) => {
    $('html, body').animate({
        scrollTop: $(e.currentTarget.dataset.myobjid).offset().top
    }, 500);
    $('html, body').animate({
      scrollTop: $(e.currentTarget.dataset.myobjid).offset().top - 200
    }, 2000);

    $(e.currentTarget.dataset.myobjid).addClass("active").siblings().removeClass("active")
    //$(".map-marker-"+hit.objectID).addClass("active").siblings().removeClass("active")
  }
  return (
    <div className="marker" data-myobjid={text} onClick={handleClick} role="presentation">
      <i className="icon-property_map_marker"></i>
    </div>
  )
}

export default Marker;